
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import './table.scss';

interface TableProps {
  tableData?: any;
}
const tableHead = [
  {
    name: "MOG Name",
  },
  {
    name: "Article Number",
  },
  {
    name: "Article Description (Standard Cost per Kg)",
  },
  {
    name: "Projected Theo Qty",
  },
  {
    name: "Requested Theo Qty",
  },
  {
    name: "Variance % on Theo",
  },
  {
    name: "Projected Revised Qty",
  },
  {
    name: "Requested Revised Qty",
  },
  {
    name: "Variance % on Revised",
  },
];
const KitchenIndentVarianceReportTable: React.FC<TableProps> = ({ tableData }) => {

  return (
    <div className="table-wrapper kitchenindentvariancereport-table">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 440 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              {tableHead.map((col: any, index: number) => (
                <TableCell key={index}>
                  <Typography variant="h6" className="table-title">
                    {col?.name}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData?.length > 0 ? (
              tableData.map((row: any, index: number) => (
                <TableRow key={index}>
                  <TableCell>{row?.mogname}</TableCell>
                  <TableCell>{row?.articlenumber}</TableCell>
                  <TableCell>{row?.articledescription}</TableCell>
                  <TableCell>{row?.projectedtheoqty} kg</TableCell>
                  <TableCell>{row?.requestedtheoqty} kg</TableCell>
                  <TableCell>{row?.varianceontheo}</TableCell>
                  <TableCell>{row?.projectedrevisedqty} kg</TableCell>
                  <TableCell>{row?.requestedrevisedqty} kg</TableCell>
                  <TableCell>{row?.varianceonrevised}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableHead.length} className="grey-bg center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </div>
  );
};

export default KitchenIndentVarianceReportTable;
